import { GridColDef } from '@mui/x-data-grid-pro'
import { Avatar } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import IconButton from '@/shared/components/IconButton/IconButton'
import ChipsCell from '@/shared/components/Table/components/ChipsCell/ChipsCell'
import styles from '../../MenuMangementColumns.module.scss'

export const useDishesColumnsConfig = (
  handleOnChange?: (id: string) => void,
  handleOnDelete?: (id: string) => void
) => {
  const { t } = useTranslation()
  const columns = useMemo<GridColDef[]>(
    () => [
      {
      field: 'id',
      headerName: 'ID',
      resizable: false,
      width: 44,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      hideable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'imageUrl',
      headerName: t('TABLE.MENU.HEADERS.IMAGE_URL'),
      resizable: false,
      hideable: false,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      flex: 1,
      disableColumnMenu: true,
      minWidth: 80,
      maxWidth: 80,
      sortable: false,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => (
        <Avatar
          src={params.value}
          alt="food-image"
          sx={{ width: '4rem', height: '3rem' }}
          variant="rounded"
        >
          <i className="las la-utensils icon-big" />
        </Avatar>
      )
    },
      {
      field: 'name',
      headerName: t('TABLE.MENU.HEADERS.NAME'),
      flex: 1,
      editable: false,

      hideable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'description',
      headerName: t('TABLE.MENU.HEADERS.DESCRIPTION'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'price',
      headerName: t('TABLE.MENU.HEADERS.PRICE'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params =>
        Array.isArray(params.value) ? (
          <ChipsCell chipPayload={params.value} />
        ) : (
          <span>{String(params.value ?? '')}</span>
        )
    },
      {
      field: 'menuNumber',
      headerName: t('TABLE.MENU.HEADERS.MENU_NUMBER'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'categories',
      headerName: t('TABLE.MENU.HEADERS.DISH_CATEGORIES'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
      {
      field: 'sizes',
      headerName: t('TABLE.MENU.HEADERS.DISH_SIZES'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
      {
      field: 'menuTypes',
      headerName: t('TABLE.MENU.HEADERS.MENU_TYPES'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
      {
      field: 'toppings',
      headerName: t('TABLE.MENU.HEADERS.TOPPINGS'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
      {
      field: 'ingredients',
      headerName: t('TABLE.MENU.HEADERS.INGREDIENTS'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 152,

      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
      {
      field: 'action',
      resizable: false,
      width: 80,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: `${styles.tableCell}`,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      pinnable: true,
      minWidth: 80,
      maxWidth: 80,
      hideable: false,
      renderHeader: params => (
        <p
          className={`${styles.tableHeaderText} body-bold-medium hideRightSeparator`}
        >
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => (
        <div className={`${styles.tableActionContainer}`}>
          <IconButton
            icon="las la-edit icon-medium"
            onClick={() => handleOnChange?.(params.row.id)}
            color="primary"
          />
          <IconButton
            icon="las la-trash icon-medium"
            onClick={() => handleOnDelete?.(params.row.id)}
            color="primary"
          />
        </div>
      )
      }
    ],
    [handleOnChange, handleOnDelete, t]
  )
  return columns
}
